'use client';

import { VersionedContent } from '@/shared/versionedContent';
import React, { useState } from 'react';
import { useGlobalClientContext } from '../common/GlobalClientContext';
import MarkupRenderer from '../privacy/MarkupRenderer';
import Header from '../components/Header';
import Footer from '../components/Footer';

interface SiteTermsProps {
  siteTermsVersions: VersionedContent[];
}

const SiteTerms: React.FC<SiteTermsProps> = ({
  siteTermsVersions
}: SiteTermsProps) => {
  const [selectedVersion, setSelectedVersion] = useState<VersionedContent>(
    siteTermsVersions[0] // Default to latest version
  );

  const {
    i18nHelper: { t },
    language
  } = useGlobalClientContext();

  // Update the selected version when language changes
  React.useEffect(() => {
    if (siteTermsVersions.length > 0) {
      setSelectedVersion(siteTermsVersions[0]);
    }
  }, [language, siteTermsVersions]);

  return (
    <div className="flex flex-col max-w-[1280px] mx-auto">
      <Header />
      <div className="flex flex-col mt-[132px] w-full gap-y-9xl mb-[260px]">
        <div className="h-[158px] space-y-7xl border border-l-0 border-r-0 border-t-0 border-b border-gray-100">
          <div className="flex flex-col gap-y-2xs">
            <h1 className="font-semibold !text-4xl leading-none !lineHeight-[10000px]">
              {t('siteTerms.notice.title', {})}
            </h1>
            <p className="text-gray-600 mb-16 font-semibold font-medium">
              {t('privacy.notice.last_updated', {
                date: selectedVersion.lastUpdated
              })}
            </p>
          </div>
        </div>

        {/* Main Content */}
        <div className="space-y-2xl">
          {selectedVersion.markdownContent && (
            <div className="w-[1280px]">
              {selectedVersion?.markdownContent?.[language] && (
                <MarkupRenderer
                  content={selectedVersion.markdownContent[language]}
                  convertEmailToLink={true}
                />
              )}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SiteTerms;
